import React from "react";

import ACIconWrapper, { ACIconProps } from "./ACIconWrapper";

export default function TagLabelIcon(props: ACIconProps) {
  return <ACIconWrapper {...props} component={IconSvg} />;
}

const IconSvg = () => {
  return (
    <svg height="1em" viewBox="0 0 17 16">
      <path
        d="M12.9987 9.74414C13.5012 9.33347 14.1676 9.98929 13.6871 10.4697L10.1666 13.8154L10.0406 13.9307C8.7027 15.0794 6.68348 14.9887 5.45471 13.6963L3.73596 11.8877C3.34125 11.4718 4.02865 10.745 4.46057 11.1992L6.17932 13.0068C7.06708 13.9408 8.54411 13.9784 9.47815 13.0908L12.9987 9.74414ZM13.3346 2C13.6107 2.00007 13.8346 2.22391 13.8346 2.5V7.33301C13.8346 7.45605 13.7901 7.56915 13.7164 7.65625C13.6903 7.7243 13.6482 7.78758 13.5914 7.84082L9.13733 12.1035C8.4635 12.7359 7.43661 12.7607 6.73499 12.1963C6.68301 12.1705 6.63445 12.1356 6.59241 12.0908L3.66272 8.96973C2.97589 8.23778 3.00571 7.08928 3.72913 6.39355L8.15491 2.13965C8.24803 2.05016 8.37249 2 8.50159 2H13.3346ZM4.42249 7.11426C4.09356 7.43051 4.07999 7.95244 4.39221 8.28516L7.27209 11.3535L7.28186 11.3438C7.59813 11.6728 8.12003 11.6863 8.45276 11.374L12.8346 7.18164V3H8.70276L4.42249 7.11426ZM10.5016 4.66699C10.8695 4.66724 11.1674 4.96513 11.1676 5.33301C11.1676 5.70104 10.8696 5.99975 10.5016 6C10.1334 6 9.83459 5.70119 9.83459 5.33301C9.83477 4.96497 10.1335 4.66699 10.5016 4.66699Z"
        fill="currentColor"
      />
    </svg>
  );
};
